import type { CalendarEvent } from '@highlight/common'

/**
 * Opens a calendar event in the browser, rewriting Google URLs to carry
 * `authuser` so the event opens in the account that actually owns it.
 *
 * Shared by the meeting cell and the flat meeting row: both fall back to the
 * calendar event when there's no brief or saved summary to drill into.
 */
export function openCalendarEventLink(meeting: CalendarEvent): void {
  if (!meeting.calendarEventLink) return
  try {
    const url = new URL(meeting.calendarEventLink)
    if (meeting.userEmail && url.hostname.includes('google.com')) {
      url.searchParams.set('authuser', meeting.userEmail)
    }
    window.open(url.toString(), '_blank', 'noopener,noreferrer')
  } catch {
    window.open(meeting.calendarEventLink, '_blank', 'noopener,noreferrer')
  }
}
